import {component} from '../form/Constant'
import {
    anySupplementaryOxygenOptions,
    bloodPressureColorData,
    bloodPressureDataRange,
    bloodPressureLimbOptions,
    bloodPressurePositionOptions,
    colors,
    confusionOptions,
    consciousnessOptions,
    oxiColorData,
    painOptions,
    pulseColorData,
    pulseDataRange,
    respirationColorData,
    respirationDataRange,
    spO2DataRange,
    tempColorData,
    temperatureDataRange,
} from '../observations/Constants'
import {parameterValue} from '../parameter/ParameterConstants'
import {convertKeyToLabel} from '../table-utils/TableUtils'

export const observationPdfKeys = {
    // Obs Data Keys
    year: 'year',
    date: 'date',
    time: 'time',
    createdAt: 'createdAt',
    levelOfConsciousness: 'levelOfConsciousness',
    confusion: 'confusion',
    respiration: 'respiration',
    heartRate: 'heartRate',
    oxygen: 'oxygen',
    systolic: 'systolic',
    diastolic: 'diastolic',
    bloodPressureLimb: 'bloodPressureLimb',
    bloodPressurePosition: 'bloodPressurePosition',
    temperature: 'temperature',
    tas: 'tas',
    news: 'news',
    comment: 'comment',
    rhythm: 'rhythm',
    bloodPressure: 'bloodPressure',
    painScore: 'pain_score',
    bloodGlucoseLevel: 'bloodGlucoseLevel',
    device: 'device',
    initials: 'initials',
    fall: 'fall',
    sleep: 'sleep',
    steps: 'steps',
    seizure: 'seizure',
    anySupplementaryOxygen: 'anySupplementaryOxygen',
    litres: 'litres',
}

export const classNameTypes = {
    col12: 'col-12',
    col6: 'col-6',
    col2: 'col-2',
    col3: 'col-3',
    col9: 'col-9',
    col4: 'col-4',
    col8: 'col-8',
    col5: 'col-5',
    col7: 'col-7',
}

export const obsColWrapperPDFData = [
    {
        key: observationPdfKeys.year,
        label: 'Year',
        colNumber: 1,
        sticky: true,
    },
    {
        key: observationPdfKeys.date,
        label: 'Date',
        colNumber: 1,
        sticky: true,
    },
    {
        key: observationPdfKeys.time,
        label: 'Time',
        colNumber: 1,
        sticky: true,
    },
    {
        key: observationPdfKeys.respiration,
        label: 'Respirations',
        colNumber: 2,
        extraColData: ['≥25', '21-24', '18-20', '15-17', '12-14', '9-11', '≤8'],
        colors: respirationColorData,
        dataRange: respirationDataRange,
    },
    {
        key: observationPdfKeys.oxygen,
        label: 'Sp02 Scale 1',
        colNumber: 2,
        extraColData: ['≥96', '94-95', '92-93', '≤91'],
        colors: oxiColorData,
        dataRange: spO2DataRange,
    },
    {
        key: observationPdfKeys.bloodPressure,
        label: 'Blood Pressure',
        colNumber: 2,
        extraColData: [
            '≥220',
            '201-219',
            '181-200',
            '161-180',
            '141-160',
            '121-140',
            '111-120',
            '101-110',
            '91-100',
            '81-90',
            '71-80',
            '61-70',
            '51-60',
            '≤50',
        ],
        colors: bloodPressureColorData,
        dataRange: bloodPressureDataRange,
    },
    {
        key: observationPdfKeys.heartRate,
        label: 'Heart Rate',
        colNumber: 2,
        extraColData: [
            '≥131',
            '121-130',
            '111-120',
            '101-110',
            '91-100',
            '81-90',
            '71-80',
            '61-70',
            '51-60',
            '41-50',
            '31-40',
            '≤30',
        ],
        colors: pulseColorData,
        dataRange: pulseDataRange,
    },
    {
        key: observationPdfKeys.temperature,
        label: 'Temperature',
        colNumber: 2,
        extraColData: [
            '≥39.1°',
            '38.1°-39.0°',
            '37.1°-38.0°',
            '36.1°-37.0°',
            '35.1°-36.0°',
            '≤35.0°',
        ],
        colors: tempColorData,
        dataRange: temperatureDataRange,
    },
    {
        key: observationPdfKeys.levelOfConsciousness,
        label: 'LOC',
        colNumber: 2,
        extraColData: ['Alert', 'C/V/P/U'],
        colors: [colors.lv1, colors.lv4],
    },
    {
        key: observationPdfKeys.news,
        label: 'NEWS2',
        colNumber: 1,
    },
    {
        key: observationPdfKeys.anySupplementaryOxygen,
        label: convertKeyToLabel(observationPdfKeys.anySupplementaryOxygen),
        colNumber: 1,
    },
    {
        key: observationPdfKeys.litres,
        label: 'Litres',
        colNumber: 1,
    },
    {
        key: observationPdfKeys.painScore,
        label: 'Pain Score',
        colNumber: 1,
    },
    {
        key: observationPdfKeys.bloodGlucoseLevel,
        label: 'Blood Glucose Level',
        colNumber: 1,
    },
    {
        key: observationPdfKeys.comment,
        label: 'Comment',
        colNumber: 1,
    },
    // {
    //     key: observationPdfKeys.rhythm,
    //     label: 'Rhythm',
    //     colNumber: 1,
    // },
    {
        key: observationPdfKeys.device,
        label: 'Device',
        colNumber: 1,
    },
    {
        key: observationPdfKeys.initials,
        label: 'Initials',
        colNumber: 1,
    },
]

export const observationListForm = [
    {
        key: '',
        description: '',
        children: [
            // {
            //     key: observationPdfKeys.createdAt,
            //     className: classNameTypes.col12,
            //     component: component.calendar,
            //     showTime: true,
            //     hideHeader: true,
            //     label: 'Date/Time',
            // },
            {
                key: observationPdfKeys.levelOfConsciousness,
                className: `md:${classNameTypes.col8} col-12 `,
                component: component.selectButton,
                options: consciousnessOptions,
                defaultValue: 'alert',
            },
            {
                key: observationPdfKeys.confusion,
                className: `md:${classNameTypes.col4} col-12`,
                component: component.selectButton,
                options: confusionOptions,
            },
            {
                key: observationPdfKeys.heartRate,
                className: classNameTypes.col6,
                component: component.slider,
                min: 20,
                max: 220,
                shorten: parameterValue.heartRate,
                dataRange: pulseDataRange,
                colors: pulseColorData,
            },
            {
                key: observationPdfKeys.respiration,
                className: `md:${classNameTypes.col6} col-12`,
                component: component.slider,
                min: 1,
                max: 50,
                shorten: parameterValue.heartRate,
                dataRange: respirationDataRange,
                colors: respirationColorData,
            },
            {
                key: observationPdfKeys.oxygen,
                className: classNameTypes.col12,
                component: component.slider,
                min: 50,
                max: 100,
                shorten: parameterValue.oxygen,
                dataRange: spO2DataRange,
                colors: oxiColorData,
            },
            {
                key: observationPdfKeys.anySupplementaryOxygen,
                className: `md:${classNameTypes.col6} col-12`,
                component: component.selectButton,
                options: anySupplementaryOxygenOptions,
                dataRange: [],
                shorten: 'Litres/%',
            },
            {
                key: observationPdfKeys.litres,
                className: `md:${classNameTypes.col6} col-12`,
                component: component.slider,
                min: 0,
                max: 15,
                step: 1,
                // colors: tempColorData,
                // dataRange: temperatureDataRange,
            },
            {
                key: observationPdfKeys.temperature,
                className: classNameTypes.col12,
                component: component.slider,
                min: 27,
                max: 43,
                step: 0.1,
                shorten: parameterValue.temperature,
                colors: tempColorData,
                dataRange: temperatureDataRange,
            },
            {
                key: observationPdfKeys.bloodPressureLimb,
                className: `md:${classNameTypes.col6} col-12`,
                component: component.selectButton,
                options: bloodPressureLimbOptions,
            },
            {
                key: observationPdfKeys.bloodPressurePosition,
                className: `md:${classNameTypes.col6} col-12`,
                component: component.selectButton,
                options: bloodPressurePositionOptions,
            },
            {
                key: observationPdfKeys.systolic,
                className: `md:${classNameTypes.col6} col-12`,
                component: component.slider,
                min: 40,
                max: 250,
                shorten: parameterValue.systolic,
                dataRange: bloodPressureDataRange,
                colors: bloodPressureColorData,
            },
            {
                key: observationPdfKeys.diastolic,
                className: `md:${classNameTypes.col6} col-12`,
                component: component.slider,
                min: 30,
                max: 140,
                shorten: parameterValue.systolic,
            },
            {
                key: observationPdfKeys.painScore,
                className: classNameTypes.col12,
                component: component.selectButton,
                options: painOptions,
            },
            {
                key: observationPdfKeys.bloodGlucoseLevel,
                className: classNameTypes.col12,
                component: component.slider,
                min: 0,
                max: 30,
                shorten: parameterValue.glucose,
            },
            {
                key: observationPdfKeys.comment,
                className: `${classNameTypes.col12}`,
                component: component.inputTextArea,
                placeholder: 'Input your comment here...',
                isObsForm: true,
                isUseAI: true,
            },
        ],
    },
]

export const shortenValueKeys = [
    observationPdfKeys.consciousness,
    observationPdfKeys.painOnMovement,
    observationPdfKeys.painAtRest,
    observationPdfKeys.rhythm,
    observationPdfKeys.comment,
]
